<script>
export default {
  name: 'MessageIconSVG'
};
</script>

<template>
  <svg id="Icon_-_biz_comm_-_email_black_24dp" data-name="Icon - biz comm - email_black_24dp" xmlns="http://www.w3.org/2000/svg" width="19.792" height="19.792" viewBox="0 0 19.792 19.792">
    <path id="Path_3988" data-name="Path 3988" d="M0,0H19.792V19.792H0Z" fill="none"/>
    <path id="Path_3989" data-name="Path 3989" d="M17.792,5.474A1.534,1.534,0,0,0,16.213,4H3.579A1.534,1.534,0,0,0,2,5.474v8.844a1.534,1.534,0,0,0,1.579,1.474H16.213a1.534,1.534,0,0,0,1.579-1.474Zm-1.579,0L9.9,9.159,3.579,5.474Zm0,8.844H3.579V6.948L9.9,10.633l6.317-3.685Z" fill="#4d4d4d"/>
  </svg>
</template>
